var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.66668C6.89533 8.66668 6 7.77134 6 6.66668C6 5.56201 6.89533 4.66668 8 4.66668C9.10467 4.66668 10 5.56201 10 6.66668C10 7.77134 9.10467 8.66668 8 8.66668Z",
    stroke: "#73737B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99987 14C7.99987 14 3.33321 10.1667 3.33321 6.66667C3.33321 4.08933 5.42254 2 7.99987 2C10.5772 2 12.6665 4.08933 12.6665 6.66667C12.6665 10.1667 7.99987 14 7.99987 14Z",
    stroke: "#73737B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.964645cd.svg";
export { ForwardRef as ReactComponent };